class FlipList {
    constructor(domList, duration = 500, movingClass = '__flipMoving__', scrollTop = 0, scrollLeft = 0) {
        this.movingClass = movingClass;
        this.flips = domList.map(k => new Flip(k, duration, movingClass, scrollTop, scrollLeft));
    }

    recordFirst() {
        this.flips.forEach(flip => flip.recordFirst());
    }

    play(callback) {
        this.flips.forEach(flip => flip.play(callback));
    }
}

class Flip {
    constructor(dom, duration = 500, movingClass, scrollTop = 0, scrollLeft = 0) {
        this.dom = dom;
        this.duration = duration;
        this.firstPosition = null;
        this.movingClass = movingClass;
        this.scrollLeft = scrollLeft;
        this.scrollTop = scrollTop;
    }

    getDomPosition() {
        const rect = this.dom.getBoundingClientRect();
        return {
            x: rect.left,
            y: rect.top,
        };
    }

    recordFirst(firstPosition) {
        if (!firstPosition) {
            firstPosition = this.getDomPosition();
        }
        this.firstPosition = { ...firstPosition };
    }

    play(callback) {
        if (!this.firstPosition) {
            console.warn('请先记录原始位置');
            return;
        }
        const lastPosition = this.getDomPosition();
        const dif = {
            x: lastPosition.x - this.firstPosition.x + this.scrollLeft,
            y: lastPosition.y - this.firstPosition.y + this.scrollTop,
        };
        if (!dif.x && !dif.y) {
            return;
        }
        this.dom.classList.add(this.movingClass);
        this.dom.animate(
            [
                { transform: `translate(${-dif.x}px, ${-dif.y}px)` },
                { transform: `translate(${-this.scrollLeft}px, ${-this.scrollTop}px)` },
            ],
            {
                duration: this.duration,
            },
        );
        setTimeout(() => {
            this.dom.classList.remove(this.movingClass);
            if (callback) {
                callback();
            }
        }, this.duration);
    }
}

export default FlipList;
